export const CRYPTO_SECRET = window.REACT_APP_PARAMS;
export const MSL_API_URL = window.REACT_APP_MSL_API_URL;
